import React, { useState } from "react";
import Header1 from "../../Components/seperate Components/Header1";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faCheck, faPhone } from "@fortawesome/free-solid-svg-icons";
import Footer from "../../Components/Footer";
import "../../Styles/Redirecting Styles/NavbarStyles/mobile.css";
import Shape2 from "../../assets/brand/choose-shape-2.png";
// import mobileApplication from "../../assets/All Images/mobile-application.jpg";
// import mobileApplication1 from "../../assets/All Images/mobile-application1.jpg";
// import mobileApplication2 from "../../assets/All Images/mobile-application2.jpg";
// import teamAssist from "../../assets/All Images/team-assist.jpg";
import billboard from "../../assets/icons/billboard.png";
import growth from "../../assets/icons/positive-dynamic.png";
import communication from "../../assets/icons/communication.png";
import revenue from "../../assets/icons/revenue.png";
import ModalVideo from "react-modal-video";
import "react-modal-video/scss/modal-video.scss";
import { Helmet } from "react-helmet";

const MobileApp = () => {
  const [isOpen, setOpen] = useState(false);

  return (
    <div>
      <Helmet>
        <title>
          Take your business to the next level with leading mobile app
          companies.
        </title>
        <meta
          name="description"
          content="Take your business to the next level with leading mobile app companies."
        />
        <meta
          name="keywords"
          content="Mobile app development, leading mobile app development company, top app development services, expert mobile application development, best app development solutions, trusted mobile app developers, premier mobile app company, top-rated app development firm, mobile app specialists, professional app development, innovative mobile app solutions, reliable mobile app services."
        />
      </Helmet>

      <Header1 />

      {/* Banner section */}
      <div
        className="bd-page-title-area bd-page-title-bg4 pt-220 pb-155"
        style={{ height: "380px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                className="bd-page-title text-center z-index"
                style={{ bottom: "45px" }}
              >
                <h2 className="breadcrumb-title1 mobile-main-title">
                  Mobile Apps Development
                </h2>
                <div className="breadcrumb-menu">
                  <nav className="breadcrumb-trail breadcrumbs">
                    <p style={{ color: "black" }}>
                      Harness the power of mobile technology to drive your
                      business forward.
                    </p>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* First Section */}
      <section className="bd-choose-area fix pb-80 pt-80">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="bd-choose-shape">
            <div className="row">
              <div className="col-xl-6 col-lg-6 order-2 order-lg-1 pr-20">
                <div className="bd-choose-text mb-30 z-index">
                  <div className="bd-section-title-wrapper mb-25">
                    {/* <h5 className="bd-section-subtitle mb-15">Why Choose Us</h5> */}
                    <h2 className="bd-section-title mb-15 first-mobile-tittle">
                      Take Your Business to the Next Level With{" "}
                      <span style={{ color: "#098FB4" }}>
                        Mobile Application
                      </span>
                    </h2>
                  </div>

                  <p
                    className="mb-20"
                    style={{ width: "95%", fontSize: "18px" }}
                  >
                    Using a mobile app for your business comes with several key
                    benefits. Firstly, your customers can access your app from
                    any device, making it more convenient for them to stay
                    connected with your business. This also helps you keep up
                    with their needs and preferences. Additionally, mobile apps
                    provide a more efficient way to engage with your customers.
                    With simple and effective tools, you can easily manage
                    interactions and enhance communication.
                  </p>
                  <p className="mb-20" style={{ fontSize: "18px" }}>
                    A mobile app helps manage key business tasks like orders,
                    payments, and reservations. It also allows you to store and
                    access important personal information with ease. Plus, it’s
                    a handy way to stay connected with friends and family.
                  </p>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 order-1 order-lg-2">
                <div className="bd-choose-img text-end  z-index">
                  <div className="row align-items-center custom-mar-15 top-resp">
                    <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                      <div className="bd-choose-img-inner mb-15 bd-choose-img-inner-1">
                        <img
                          // src={mobileApplication}
                          className="bordertop-img1"
                          alt="img not found"
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                      <div className="bd-choose-img-inner mb-15">
                        <img
                          // src={mobileApplication1}
                          className="bordertop-img2"
                          alt="img not found"
                        />
                      </div>
                      <div className="bd-choose-img-inner mb-15">
                        <img
                          // src={mobileApplication2}
                          className="bordertop-img3"
                          alt="img not found"
                        />
                      </div>
                    </div>
                  </div>
                  <img
                    className="bd-choose-shape bd-choose-shape-2"
                    src={Shape2}
                    alt="shape img not found"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <ModalVideo
          autoplay
          isOpen={isOpen}
          channel="youtube"
          videoId="u-2jURch9-4"
          onClose={() => setOpen(false)}
        ></ModalVideo>
        <button
          className="btn btn responsive_digital first_pop_mobile"
          onClick={() => setOpen(true)}
        >
          <FontAwesomeIcon
            icon={faPlay}
            className="play_bt_vid play_transition"
          />
        </button> */}
      </section>

      {/* Secound section*/}
      <section className="bd-choose-area  fix">
        <div className="container" style={{ maxWidth: "1300px" }}>
          <div className="bd-choose-shape">
            <div className="row second-mobile-responsive">
              <div className="col-xl-6 col-lg-6 order-2 order-lg-1 second-mobile-section1">
                {/* <div className="ablog ablog-4 mb-60"> */}
                <h2 className="bd-section-title mb-10 ml-15 four-point-tittle">
                  Transform the way your business operates.
                </h2>
                <div className="bd-choose-text z-index">
                  <div className="bd-section-title-wrapper">
                    <p className="ml-25 mobile-para1">
                      Mobile app development can transform businesses by making
                      it easier to access information and carry out transactions
                      anytime, anywhere. With a mobile app, businesses can save
                      time and effort without the need for multiple devices.
                      Plus, it helps businesses stay connected with customers
                      and expand their online presence.
                    </p>
                  </div>
                  <div></div>
                </div>
                {/* </div> */}
              </div>
              <div className="col-xl-6 col-lg-6 order-1 order-lg-2 mt-0 second-mobile-section2">
                <div className="bd-choose-img mb-30 z-index">
                  <div className="bd-choose-info-wrapper">
                    <div className="container">
                      <div className="row mb-50">
                        <div className="col four-section mr-50">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src={billboard} />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Boosted Brand Recognition
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div className="col">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src={growth} />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Greater Business Engagement Level{" "}
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row ml-15">
                      <div className="col four-section2 mr-50">
                        <div className="animate-hover">
                          <div className="bd-choose-info-icon mb-15">
                            <i>
                              <img src={communication} />
                            </i>
                          </div>
                          <div className="bd-choose-info-text">
                            <h2
                              className="bd-choose-info-title mb-15"
                              style={{ color: "#5e5858" }}
                            >
                              Straightforward Communication Choices
                            </h2>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="animate-hover">
                          <div className="bd-choose-info-icon mb-15">
                            <i>
                              <img src={revenue} />
                            </i>
                          </div>
                          <div className="bd-choose-info-text">
                            <h2
                              className="bd-choose-info-title mb-15"
                              style={{ color: "#5e5858" }}
                            >
                              Driving Sales and Growing Revenue
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Third Section */}

      <section className="bd-about-six-area  pt-80">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <h2 className="bd-section-title mb-20 third-mobile-tittle">
            Right <span style={{ color: "#098FB4" }}>Mobile Application </span>,
            Boost your business efficiency and stay competitive.{" "}
          </h2>
          <ul style={{ color: "black", fontSize: "20px", listStyle: "none" }}>
            <li>
              Mobile app development involves multiple stages, such as design,
              development, testing, and launch. Depending on its design, a
              mobile app can be either a native or a hybrid application.
            </li>
          </ul>
          <div
            className="bd-service service-mobile mb-30 mt-30"
            style={{ backgroundColor: "var(--clr-bg-gray)" }}
          >
            <div className="row third-mobile-section1">
              <div className="col-lg-6 mobile-subpoint-section">
                <h4 style={{ fontWeight: "600" }}>Native Mobile Application</h4>
                <div className="bd-about-six-text">
                  <div className="bd-section-title-wrapper mb-25">
                    <p style={{ fontSize: "18px", lineHeight: "1.75" }}>
                      Native applications are mobile apps designed specifically
                      for a particular operating system. For example, Swift is
                      used for iOS, while Java and Kotlin are used for Android.
                      These apps are built exclusively for their respective
                      platforms and cannot run on others. Native apps can also
                      be updated through the App Store or Google Play Store.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-8 mobile-subpoint-section ">
                <div className="bd-about-six-img">
                  <div className="bd-about-six-feature six-feature-mobile pl-140">
                    <h4 className="mb-15" style={{ fontWeight: "600" }}>
                      Key Features
                    </h4>
                    <ul className="">
                      <li
                        style={{
                          fontSize: "18px",
                          color: "var(--clr-body-text)",
                        }}
                      >
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>{" "}
                        Can be accessed through the icons on the home screen.
                      </li>
                      <li
                        style={{
                          fontSize: "18px",
                          color: "var(--clr-body-text)",
                        }}
                      >
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>{" "}
                        Delivering the fastest and most reliable experience.
                      </li>
                      <li
                        style={{
                          fontSize: "18px",
                          color: "var(--clr-body-text)",
                        }}
                      >
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>{" "}
                        Advantage of numerous mobile features
                      </li>
                      <li
                        style={{
                          fontSize: "18px",
                          color: "var(--clr-body-text)",
                        }}
                      >
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>{" "}
                        The application can be used without an internet
                        connection.{" "}
                      </li>
                      <li
                        style={{
                          fontSize: "18px",
                          color: "var(--clr-body-text)",
                        }}
                      >
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>{" "}
                        Tend to Got Less Bugs
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="bd-service mb-30 service-mobile"
            style={{ backgroundColor: "var(--clr-bg-gray)" }}
          >
            <div className="row third-mobile-section1">
              <div className="col-lg-6 mobile-subpoint-section">
                <h4 style={{ fontWeight: "600" }}>Hybrid Mobile Application</h4>
                <div className="bd-about-six-text">
                  <div className="bd-section-title-wrapper mb-25">
                    <p style={{ fontSize: "18px", lineHeight: "1.75" }}>
                      Web browsers and app stores let users access and download
                      hybrid apps. Just like web applications, hybrid apps are
                      built using JavaScript and HTML5. They don’t need much
                      upkeep. But ah, hybrid apps not as fast as native apps
                      because their speed depends on the browser speed. These
                      apps are designed to display website content in an
                      app-like way.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-8 mobile-subpoint-section">
                <div className="bd-about-six-img">
                  <div className="bd-about-six-feature six-feature-mobile pl-140">
                    <h4 className="mb-15" style={{ fontWeight: "600" }}>
                      Key Features
                    </h4>
                    <ul className="">
                      <li
                        style={{
                          fontSize: "18px",
                          color: "var(--clr-body-text)",
                        }}
                      >
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>{" "}
                        Can work across different platforms
                      </li>
                      <li
                        style={{
                          fontSize: "18px",
                          color: "var(--clr-body-text)",
                        }}
                      >
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>{" "}
                        The maintenance is easy
                      </li>
                      <li
                        style={{
                          fontSize: "18px",
                          color: "var(--clr-body-text)",
                        }}
                      >
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>
                        High-speed capability
                      </li>
                      <li
                        style={{
                          fontSize: "18px",
                          color: "var(--clr-body-text)",
                        }}
                      >
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>{" "}
                        Attractive user interface
                      </li>
                      <li
                        style={{
                          fontSize: "18px",
                          color: "var(--clr-body-text)",
                        }}
                      >
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>{" "}
                        Target a Wider User Base
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fourth Section */}

      <section className="bd-about-six-area pt-70">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row">
            <h2 className="bd-section-title mb-15 fourth-sec-tittle">
              <span style={{ color: "#098FB4" }}>Mobile Application </span> is
              an essential part of any business{" "}
            </h2>
            <div className="col-lg-6 " style={{ width: "100%" }}>
              <div className="bd-about-six-text">
                <div className="bd-section-title-wrapper ">
                  <div className="bd-about-six-feature">
                    <p
                      style={{
                        fontSize: "20px",
                        fontWeight: "600",
                        marginBottom: "25px",
                      }}
                    >
                      Got many companies providing mobile app services, so must
                      choose the right one for business.
                    </p>
                    <ul className="">
                      <li style={{ fontSize: "22px", fontWeight: "600" }}>
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>{" "}
                        Do your research{" "}
                      </li>
                      <p className="pb-20 pl-25">
                        Before selecting a company to develop your mobile app,
                        it’s good to do some research and see what they provide.
                        This way, you can pick the right company that suits your
                        needs.
                      </p>

                      <li style={{ fontSize: "22px", fontWeight: "600" }}>
                        <i>
                          <FontAwesomeIcon icon={faCheck} />
                        </i>{" "}
                        Look for features
                      </li>
                      <p className="pl-25">
                        If you’re finding a company to develop your mobile app,
                        make sure to consider features that matter to your
                        business. This could be things like customer loyalty,
                        advertising, or functions that suit your industry or
                        product.
                      </p>
                      <p className="pl-25">
                        We’re all about top-notch customer service and building
                        applications that are super easy to use and navigate. We
                        make the effort to understand your needs and work
                        closely with you to develop an application that’s both
                        innovative and successful.
                      </p>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fiveth Section */}

      <section className="bd-service-details-area pt-80 pb-80">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row ">
            <div className="col-lg-8" style={{ width: "100%" }}>
              <div className="bd-service-details1">
                <div className="row pb-10 fifth-responsive-sec">
                  <div className="col-xl-5 col-lg-6 mobile-fifth-sec1">
                    <h5 className="mb-10 fourth-sec-tittle">
                      The team of tech-savvy folks, always ready to lend a hand
                      for your business.
                    </h5>
                    <div className="bd-service-details-feature ">
                      <div>
                        <p style={{ fontSize: "17px" }}>
                          "Our team can help you build a smart and efficient
                          mobile app that’s just right for your business. We
                          also make sure the design and development are
                          user-friendly and easy to navigate. With our
                          experienced mobile app developers, your business will
                          not only run smoother but also look solid. Drop us a
                          message today to find out how we can help create the
                          perfect mobile app for you!
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-6 mobile-fifth-sec2">
                    <div
                      className="bd-service-details-feature-img"
                      style={{ paddingTop: "10px" }}
                    >
                      <img
                        // src={teamAssist}
                        alt="img not found"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section
        className="bd-video-area pt-135 pb-130"
        style={{ backgroundColor: "#01536E" }}
      >
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row responsive-banner">
            <div className="col-lg-12 first_section">
              <div className="bd-video-text">
                <h2 className="bd-video-title first-para-resp">
                  Looking for an expert in app development
                </h2>
                <p className="contact_section second-para-resp">
                  You're in the right place, right time
                </p>
                <p className="contact_subtext">
                  Wah, this app development damn solid! Let's get started now
                </p>
              </div>
            </div>
            <div className="col-lg-12 second_section">
              <div className="contact-stuff pt-30">
                <div className="contact_icon icon_respon pt-15 pl-50">
                  <FontAwesomeIcon
                    icon={faPhone}
                    style={{ fontSize: "30px" }}
                  />
                </div>
                <div className="contact_txt ">
                  <p className="contact-sub-text">CALL US NOW</p>
                  <a
                    href="tel:+65 87852030"
                    style={{ fontSize: "17px" }}
                    className="mbb-5 pb-20"
                  >
                    +65 87852030
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MobileApp;
